import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";

@Component("ShareOnRoundEnd")
export class ShareOnRoundEndSchema extends Schema {
  @type("number")
  @defaultValue(-1)
  owner: number;

  @type(["number"])
  @defaultValue([])
  entities: number[];
}

class ShareOnRoundEndSystem implements System {
  schema = ShareOnRoundEndSchema;
  type = "ShareOnRoundEnd";

  dependencies = ["Child"];

  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      gameModel.addIfMissing(parent, ShareOnRoundEndSchema);
      const parentData = gameModel.getTypedUnsafe(parent, ShareOnRoundEndSchema);
      parentData.entities.push(entity);
    }
  }
}

registerSystem(ShareOnRoundEndSystem);
